/**
 * 求人票ページ
 */

import Slick from 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

class Job {
    constructor() {
        // 画像スライダー
        $('.job_slider').slick({
            autoplay: true,
            speed: 800,
            lazyLoad: 'progressive',
            arrows: true,
            dots: true,
            centerMode: false,
        });

        // JSON-LD作成
        if( document.getElementById('json-ld-url') ){
            this.makeJsonLD();
        }
        
        // お気に入りに追加・削除
        this.addFavoriteBtnEls = document.querySelectorAll('.addFavorite');
        if( this.addFavoriteBtnEls.length > 0 ){
            this.addFavoriteBtnEls.forEach(el => el.addEventListener('click', () => this.toggleFavorite(el)));
        }
    }

    /**
     * JSON-LD作成
     */
    async makeJsonLD() {
        let content1 = document.getElementById('info_recruit').innerHTML.replaceAll('"', '\\"');
        let content2 = document.getElementById('info_clinic').innerHTML.replaceAll('"', '\\"');
        content1 = content1.replace(/\s+/g, '');
        content2 = content2.replace(/\s+/g, '');

        const url = document.getElementById('json-ld-url').value;
        let structuredDataText = await fetch(url);
        structuredDataText = await structuredDataText.text();
        structuredDataText = structuredDataText.replace('replace_ld_json_description', content1 + content2);
        const script = document.createElement('script');
        script.setAttribute('type', 'application/ld+json');
        script.textContent = structuredDataText;
        document.head.appendChild(script);
    }

    /**
     * お気に入りに追加・削除
     */
    async toggleFavorite(el) {
        const page = document.body.classList.contains('front-job-show') ? 'show' : 'index';
        let url;
        if( page == 'show' ){
            url = !el.classList.contains('added')
                ? document.getElementById('favorite-store-url').value
                : document.getElementById('favorite-destroy-url').value;
        }else{
            url = !el.classList.contains('added')
                ? el.closest('div').querySelector('.favorite-store-url').value
                : el.closest('div').querySelector('.favorite-destroy-url').value;
        }
        

        const method = !el.classList.contains('added')
            ? 'POST'
            : 'DELETE';

        let res = await fetch(url, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                _token: document.querySelector('[name=csrf-token]').content,
                job_id: el.dataset.jobId,
                from: 'ajax',
            })
        });

        if( !res.ok ) throw new Error(res.statusText);
        res = await res.json();
        if( res.status == 'error' ) throw new Error(res.message);

        if( !el.classList.contains('added') ){
            if( page == 'show' ){
                document.querySelectorAll('.addFavorite').forEach(_el => {
                    _el.children[0].textContent = 'キープ中';
                    _el.classList.add('added');
                });
            }else{
                el.children[0].textContent = 'キープ中';
                el.classList.add('added');
            }
        }else{
            if( page == 'show' ){
                document.querySelectorAll('.addFavorite').forEach(_el => {
                    _el.children[0].textContent = 'キープ';
                    _el.classList.remove('added');
                });
            }else{
                el.children[0].textContent = 'キープ';
                el.classList.remove('added');
            }
        }
    }
}

const job = new Job();
